import { ComponentMap } from '@cinch-nx/data-storyblok'
import { sharedStoryblokComponents } from '@cinch-nx/storyblok'
import {
  AuthorByline,
  CtaButton,
  FaqSection,
  HeroCtaButton,
  HighlightsSection,
  IntroSection,
  TextInlineImage,
  TextInlineImageSection,
} from './blocks'
import Video from '../video/video'

export const landingStoryblokComponents: ComponentMap = {
  AuthorByline,
  FaqSection,
  CtaButton,
  HeroCtaButton,
  HighlightsSection,
  IntroSection,
  LandingTextInlineImage: TextInlineImage,
  LandingTextInlineImageSection: TextInlineImageSection,
  YoutubeVideo: Video,
}

export const storyblokComponents: ComponentMap = {
  ...sharedStoryblokComponents,
  ...landingStoryblokComponents,
}
